import {
  Box,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_PAGE_SIZE,
  PAGE_SIZE_OPTIONS,
} from "../constants/pagination";

const ListPaginationBar = ({
  page,
  pageSize = DEFAULT_PAGE_SIZE,
  totalCount,
  onPageChange,
  onPageSizeChange,
  isRTL = false,
}) => {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize) || 1);
  const from = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);

  if (totalCount === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "stretch", sm: "center" },
        gap: 2,
        mt: 2,
        pt: 2,
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t("referencePages.paginationShowing", { from, to, total: totalCount })}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: { xs: "center", sm: isRTL ? "flex-start" : "flex-end" },
          gap: 2,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            displayEmpty
            aria-label={t("referencePages.rowsPerPage")}
          >
            <MenuItem value={DEFAULT_PAGE_SIZE}>
              {t("referencePages.rowsPerPageOption", {
                count: DEFAULT_PAGE_SIZE,
              })}
            </MenuItem>
            {PAGE_SIZE_OPTIONS.map((size) => (
              <MenuItem key={size} value={size}>
                {t("referencePages.rowsPerPageOption", { count: size })}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {totalPages > 1 && (
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, newPage) => onPageChange(newPage)}
            color="primary"
            size="medium"
            showFirstButton
            showLastButton
            dir={isRTL ? "rtl" : "ltr"}
          />
        )}
      </Box>
    </Box>
  );
};

export default ListPaginationBar;
